import { useStore } from '../store';
import { VALID_FLAG_VALUE } from '../flows/achOutTransfer/constants';
import { FEATURE_FLAG } from '../constants/general';

const validateAccountType = (customerProfile: string, allowedTypes: string[]) => allowedTypes.includes(customerProfile);

export const validateFeatureFlag = (flagName: string, cb?: () => void) => {
  const { user, summary } = useStore.getState();
  const featureFlagData = user?.filteredInitializeArr?.filter(flag => flag.name === flagName)[0];
  if (featureFlagData?.selected === VALID_FLAG_VALUE) {
    return validateAccountType(summary?.customerProfileInfo?.customerProfile ?? '', featureFlagData.customerProfilesEnumList);
  }
  if (cb) cb();
  return false;
};

/* *
** Indicate that feature flag is SHOW, but the current account type is not supported
* */
export const featureFlagMightBeAvailable = (flagName: string) => {
  const { user } = useStore.getState();
  const featureFlagData = user?.filteredInitializeArr?.filter(flag => flag.name === flagName)[0];
  if (featureFlagData?.selected !== VALID_FLAG_VALUE) {
    return false;
  }
  return (!!featureFlagData?.customerProfilesEnumList?.length && validateFeatureFlag(FEATURE_FLAG.PLAN_UPGRADE));
};

export const canUpgradeToUseFeature = (flagName: string) => (featureFlagMightBeAvailable(flagName) && validateFeatureFlag(FEATURE_FLAG.PLAN_UPGRADE));
